<template>
  <div>
    <div class="seccion-02">
        <img src="../../assets/style/images/demo.jpg" class="d-block" alt="...">
    </div>

    <section class="seccion-01">
        <div class="container justify-content-center">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="card-organigrama">
                        <h4 class="titulo_C01 mt-3 mb-4">Difusión</h4>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
                    <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
                        <h6 class="subtitulo_Ad04">Divulgación del conocimiento</h6>
                    </div>
                    <div id="accordion" class="accordion">
                        <class class="card card-acordion"></class>
                        <div class="card-header header-testi collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                            <a class="card-title">
                                <h6 class="">Ciencia y tecnología</h6>
                            </a>
                        </div>
                        <div id="collapseOne" class="card-body header-testi collapse" data-parent="#accordion">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <h6 class="titulo_Ad04">Cultura</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>